import { render } from "./MMyRelease.vue?vue&type=template&id=5c79a8c2&scoped=true"
import script from "./MMyRelease.vue?vue&type=script&lang=js"
export * from "./MMyRelease.vue?vue&type=script&lang=js"

import "./MMyRelease.vue?vue&type=style&index=0&id=5c79a8c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c79a8c2"]])

export default __exports__